/**
 * The locales the SEO copy exists in.
 *
 * Kept free of imports so client code (the menu) can read it without dragging
 * serverSideTranslations, and its `fs` dependency, into the browser bundle. A test locks
 * these to next-i18next.config.js, which types as string[] and would lose the literal
 * union that SeoLocale does real work with.
 */
export const SEO_LOCALES = ['sv', 'en'] as const

export type SeoLocale = (typeof SEO_LOCALES)[number]

/**
 * Swedish is the default locale, so its urls carry no prefix and it is the x-default.
 * Narrowed to the literal rather than annotated as SeoLocale, so indexing a per-locale
 * map with it reaches the one entry every page is guaranteed to have.
 */
export const SEO_DEFAULT_LOCALE = 'sv' satisfies SeoLocale

export const isSeoLocale = (locale?: string): locale is SeoLocale =>
  SEO_LOCALES.includes(locale as SeoLocale)

/** The locale prefix a public url carries. Swedish is the default and has none. */
export const localePrefix = (locale?: string) =>
  locale && locale !== SEO_DEFAULT_LOCALE ? `/${locale}` : ''
